<template>
    <ies-form-field :field="field">
        <input type="hidden" :name="field.fieldName" :value="field.value">

        <v-row no-gutters>
            <v-col cols="auto" class="mr-3 checkbox" v-for="day in [
                { id: 'monday',    label: 'Mon', model: 'monday' },
                { id: 'tuesday',   label: 'Tue', model: 'tuesday' },
                { id: 'wednesday', label: 'Wed', model: 'wednesday' },
                { id: 'thursday',  label: 'Thu', model: 'thursday' },
                { id: 'friday',    label: 'Fri', model: 'friday' },
                { id: 'saturday',  label: 'Sat', model: 'saturday' },
                { id: 'sunday',    label: 'Sun', model: 'sunday' },
            ]" :key="day.id">
                <label :for="day.id">{{ day.label }}</label>
                <input :id="day.id" :name="day.id" type="checkbox" v-model="week[day.model]">
            </v-col>
        </v-row>
    </ies-form-field>
</template>

<script>
    /**
     * Allows the user to select days of the week for which the given
     * field will represent, as used for example when entering the 
     * checkin/out restrictions' days for hotels' rate types.
     *
     * The database stores these values as integers/tinyintegers
     * with each day represented as a bolean value by a bit, but the
     * user expects to interact with them using checkboxes to toggle
     * each day separately, meaning we will display 7 checkboxes per
     * field.  We will use view models to abstract the data from the 
     * data model it is representing as it will make it cleaner and
     * safer to modify the UI, provided we keep the two models in 
     * synchronisation
     *
     * Note that the days of the week in i-escape's system correlate 
     * to the days of the business week, not the common week, so all
     * weeks begin on Monday
     */
    export default {
        name: 'ies-dayOfWeek',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                /** @var object week - A view model representing the days of the week and a boolean flag for each - this will be used to power the UI easier than the data model */
                week: {'monday': false, 'tuesday': false, 'wednesday':false, 'thursday':false, 'friday':false, 'saturday':false, 'sunday':false},
            }
        },
        methods: {
            /**
             * Update the view models so that the view model data 
             * reflects the underlying data model for the field 
             * which will actually be saved to the database later
             */
            updateViewFromModel: function(){
                this.week.monday    = this.field.value & 1;
                this.week.tuesday   = this.field.value & 2;
                this.week.wednesday = this.field.value & 4;
                this.week.thursday  = this.field.value & 8;
                this.week.friday    = this.field.value & 16;
                this.week.saturday  = this.field.value & 32;
                this.week.sunday    = this.field.value & 64;
            },

            /**
             * Update the data model for the field to match the data
             * represented in the view model which powers the user 
             * interface so that it matches what the user has entered
             */
            updateModelFromView: function(newValue){
                this.field.value = (this.week.monday)   ? this.field.value |= 1  : this.field.value & ~1;
                this.field.value = (this.week.tuesday)  ? this.field.value |= 2  : this.field.value & ~2;
                this.field.value = (this.week.wednesday)? this.field.value |= 4  : this.field.value & ~4;
                this.field.value = (this.week.thursday) ? this.field.value |= 8  : this.field.value & ~8;
                this.field.value = (this.week.friday)   ? this.field.value |= 16 : this.field.value & ~16;
                this.field.value = (this.week.saturday) ? this.field.value |= 32 : this.field.value & ~32;
                this.field.value = (this.week.sunday)   ? this.field.value |= 64 : this.field.value & ~64;
            }
        },

        created:function() {
            this.updateViewFromModel();
        },

        /**
         * In the event that the user changes the view model's data then
         * we need to trigger a corresponding change to the data model too
         */
        watch: {
            'week.monday':    function(){ this.updateModelFromView(); },
            'week.tuesday':   function(){ this.updateModelFromView(); },
            'week.wednesday': function(){ this.updateModelFromView(); },
            'week.thursday':  function(){ this.updateModelFromView(); },
            'week.friday':    function(){ this.updateModelFromView(); },
            'week.saturday':  function(){ this.updateModelFromView(); },
            'week.sunday':    function(){ this.updateModelFromView(); }
        }
    }
</script>
